import { isEmpty } from 'lodash';
import { ELSTokenHelper } from '@els/els-ui-common-react';
import {
  CourseSectionDto,
  EvolveProductDto,
  EvolveProductTypeKey
} from '../../apis/eols-course-crud/eols-course-crud.dtos';
import { ELSTokenUser } from '../../models/els.dtos';

const hiddenProductTypes = [
  EvolveProductTypeKey.SHERPATH_EBOOK_COMPONENT_NSS,
  EvolveProductTypeKey.SHERPATH_COMPONENT_NSS,
];
export const getEvolveProductsFromCourseSection = (currentCourse: CourseSectionDto): EvolveProductDto[] => {
  if (isEmpty(currentCourse) || isEmpty(currentCourse.entitlements)) {
    return [];
  }

  return currentCourse.entitlements.reduce((acc, entitlement) => {

    if (!entitlement || !entitlement.data) {
      return acc;
    }

    const parsedEntitlement = JSON.parse(entitlement.data) as EvolveProductDto;
    if (!parsedEntitlement || !parsedEntitlement.productTypeKey || hiddenProductTypes.includes(parsedEntitlement.productTypeKey)) {
      return acc;
    }
    return [...acc, parsedEntitlement];
  }, []);
};

export const getTokenIsbns = (): string => {
  const tokenUser: ELSTokenUser = ELSTokenHelper.getUser();
  if (!tokenUser || !tokenUser.appParams) {
    return null;
  }
  return tokenUser.appParams.isbns ? tokenUser.appParams.isbns : null;
};

export const getTokenIsbnsArray = (): string[] => {
  const tokenIsbns = getTokenIsbns();
  if (!tokenIsbns) {
    return [];
  }
  return tokenIsbns
    .split(',')
    .map((isbn) => {
      return isbn.trim();
    })
    .sort((a, b) => {
      return a.localeCompare(b);
    });
};
